import {inject} from "@angular/core";
import {AuthService} from "../services/auth.service";
import {Router} from "@angular/router";
import {RoutesConst} from "../../data/const/routes.const";

export namespace AuthGuard {
  export const canActivate = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (!authService.isLoggedIn()) {
      router.navigate([RoutesConst.SIGN_IN]).then();
    }
    return authService.isLoggedIn();
  }
}
